import { render } from "./VoicemailGreetingDialog.vue?vue&type=template&id=4f0f5844&scoped=true"
import script from "./VoicemailGreetingDialog.vue?vue&type=script&lang=js"
export * from "./VoicemailGreetingDialog.vue?vue&type=script&lang=js"

import "./VoicemailGreetingDialog.vue?vue&type=style&index=0&id=4f0f5844&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0f5844"]])

export default __exports__